import { useTranslations } from "next-intl";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Size } from "src/config/sizes";
import cmToIn from "src/helpers/cmToIn";
import getSizeData from "src/helpers/getSizeData";

interface SizesExplanationProps {
  selectedSize: string | null;
}

const SizesExplanation = ({ selectedSize }: SizesExplanationProps) => {
  const t = useTranslations("ProductOverview");

  const [sizeData, setSizeData] = useState<Size | null>();

  const { query } = useRouter();

  useEffect(() => {
    if (selectedSize) setSizeData(getSizeData(selectedSize.toLowerCase()));
  }, [selectedSize]);

  if (sizeData)
    return (
      <>
        <p className="py-2.5 text-sm font-medium text-black">
          {t("shemsi_size_corresponds_to", {
            size: sizeData.name.toUpperCase(),
            european_size:
              typeof sizeData.equivalence === "number"
                ? sizeData.equivalence
                : `${t("from")} ${sizeData.equivalence.from} ${t("to")} ${
                    sizeData.equivalence.to
                  }`,
            waist_size_from: sizeData.waist.from,
            waist_size_to: sizeData.waist.to,
            hip_size_from: sizeData.hip.from,
            hip_size_to: sizeData.hip.to,
          })}
        </p>
        {query.productHandle === "alexandria" && (
          <p className="py-2.5 text-sm font-semibold text-black">
            {t("alexandria_model_size_up")}
          </p>
        )}

        <section className="flex justify-center gap-12 sm:gap-16 lg:gap-20">
          <div className="flex flex-col gap-2.5 sm:flex-row">
            <Image
              src="/images/product-page/size-select/waist-size-measure.png"
              alt="Waist size"
              className="w-[140px]"
              sizes="10rem"
              width={0}
              height={0}
            />
            <div className="flex flex-col items-center justify-center leading-3 text-gray-400">
              <span className="text-sm font-bold sm:text-base lg:text-lg ">
                {sizeData.waist.from}-{sizeData.waist.to}cm
              </span>
              <span className="lg:text-md text-xs sm:text-sm">
                {cmToIn(sizeData.waist.from)}-{cmToIn(sizeData.waist.to)}in
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-2.5 sm:flex-row">
            <Image
              src="/images/product-page/size-select/hip-size-measure.png"
              alt="Hip size"
              className="w-[140px]"
              sizes="10rem"
              width={0}
              height={0}
            />
            <div className="flex flex-col items-center justify-center pe-3 leading-3 text-gray-400 md:pe-0">
              <span className="text-sm font-bold sm:text-base lg:text-lg">
                {sizeData.hip.from}-{sizeData.hip.to}cm
              </span>
              <span className="lg:text-md text-xs sm:text-sm">
                {cmToIn(sizeData.hip.from)}-{cmToIn(sizeData.hip.to)}in
              </span>
            </div>
          </div>
        </section>
      </>
    );
  else return <></>;
};

export default SizesExplanation;
